import { c as _c } from "react/compiler-runtime";
/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from "@tanstack/react-query";
import { useGatewayContext, GatewayContext } from "./gatewayContext";
import type * as Fetcher from "./gatewayFetcher";
import { gatewayFetch } from "./gatewayFetcher";
import type * as Schemas from "./gatewaySchemas";
export type GetAdvisorsError = Fetcher.ErrorWrapper<undefined>;
export type GetAdvisorsResponse = Schemas.Advisor[];
export type GetAdvisorsVariables = GatewayContext["fetcherOptions"];
export const fetchGetAdvisors = (variables: GetAdvisorsVariables, signal?: AbortSignal) => gatewayFetch<GetAdvisorsResponse, GetAdvisorsError, undefined, {}, {}, {}>({
  url: "/advisors",
  method: "get",
  ...variables,
  signal
});
export const useGetAdvisors = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/advisors",
      operationId: "getAdvisors",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetAdvisors({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PatchAdvisorPathParams = {
  advisorId: string;
};
export type PatchAdvisorError = Fetcher.ErrorWrapper<undefined>;
export type PatchAdvisorVariables = {
  body?: Schemas.AdvisorPatch;
  pathParams: PatchAdvisorPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchPatchAdvisor = (variables: PatchAdvisorVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Advisor, PatchAdvisorError, Schemas.AdvisorPatch, {}, {}, PatchAdvisorPathParams>({
  url: "/advisors/{advisorId}",
  method: "patch",
  ...variables,
  signal
});
export const usePatchAdvisor = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPatchAdvisor({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetAdvisorMeetingsPathParams = {
  advisorId: string;
};
export type GetAdvisorMeetingsError = Fetcher.ErrorWrapper<undefined>;
export type GetAdvisorMeetingsResponse = Schemas.AdvisorMeeting[];
export type GetAdvisorMeetingsVariables = {
  pathParams: GetAdvisorMeetingsPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetAdvisorMeetings = (variables: GetAdvisorMeetingsVariables, signal?: AbortSignal) => gatewayFetch<GetAdvisorMeetingsResponse, GetAdvisorMeetingsError, undefined, {}, {}, GetAdvisorMeetingsPathParams>({
  url: "/advisors/{advisorId}/meetings",
  method: "get",
  ...variables,
  signal
});
export const useGetAdvisorMeetings = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/advisors/{advisorId}/meetings",
      operationId: "getAdvisorMeetings",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetAdvisorMeetings({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetAircallRedirectQueryParams = {
  phoneNumber: string;
};
export type GetAircallRedirectError = Fetcher.ErrorWrapper<undefined>;
export type GetAircallRedirectVariables = {
  queryParams: GetAircallRedirectQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetAircallRedirect = (variables: GetAircallRedirectVariables, signal?: AbortSignal) => gatewayFetch<undefined, GetAircallRedirectError, undefined, {}, GetAircallRedirectQueryParams, {}>({
  url: "/gateway/v1/aircall/redirect",
  method: "get",
  ...variables,
  signal
});
export const useGetAircallRedirect = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/aircall/redirect",
      operationId: "getAircallRedirect",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetAircallRedirect({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostApplicationQueryParams = {
  /**
   * The lead ID of the customer, in case they had opted in before.
   */
  leadId?: string;
};
export type PostApplicationError = Fetcher.ErrorWrapper<undefined>;
export type PostApplicationVariables = {
  body: Schemas.Application;
  queryParams?: PostApplicationQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchPostApplication = (variables: PostApplicationVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Application, PostApplicationError, Schemas.Application, {}, PostApplicationQueryParams, {}>({
  url: "/gateway/v1/application",
  method: "post",
  ...variables,
  signal
});
export const usePostApplication = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostApplication({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetApplicationResultsPathParams = {
  /**
   * The UUID of the application
   */
  applicationId: string;
};
export type GetApplicationResultsError = Fetcher.ErrorWrapper<undefined>;
export type GetApplicationResultsVariables = {
  pathParams: GetApplicationResultsPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetApplicationResults = (variables: GetApplicationResultsVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Application, GetApplicationResultsError, undefined, {}, {}, GetApplicationResultsPathParams>({
  url: "/gateway/v1/application/{applicationId}",
  method: "get",
  ...variables,
  signal
});
export const useGetApplicationResults = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/application/{applicationId}",
      operationId: "getApplicationResults",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetApplicationResults({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetAdvisorCalendarQueryParams = {
  applicationId?: string;
  leadId?: string;
};
export type GetAdvisorCalendarError = Fetcher.ErrorWrapper<undefined>;
export type GetAdvisorCalendarVariables = {
  queryParams?: GetAdvisorCalendarQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetAdvisorCalendar = (variables: GetAdvisorCalendarVariables, signal?: AbortSignal) => gatewayFetch<string, GetAdvisorCalendarError, undefined, {}, GetAdvisorCalendarQueryParams, {}>({
  url: "/gateway/v1/advisor-calendar",
  method: "get",
  ...variables,
  signal
});
export const useGetAdvisorCalendar = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/advisor-calendar",
      operationId: "getAdvisorCalendar",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetAdvisorCalendar({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetAssumptionsQueryParams = {
  /**
   * The federal state to retrieve the assumptions for. If not filled, the default federal state will be used.
   */
  federalState?: string;
  /**
   * The zip code to retrieve the assumptions for
   */
  zipCode?: string;
};
export type GetAssumptionsError = Fetcher.ErrorWrapper<undefined>;
export type GetAssumptionsVariables = {
  queryParams?: GetAssumptionsQueryParams;
} & GatewayContext["fetcherOptions"];

/**
 * Retrieve all assumptions for the given parameters
 */
export const fetchGetAssumptions = (variables: GetAssumptionsVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Assumptions, GetAssumptionsError, undefined, {}, GetAssumptionsQueryParams, {}>({
  url: "/gateway/v1/assumption",
  method: "get",
  ...variables,
  signal
});

/**
 * Retrieve all assumptions for the given parameters
 */
export const useGetAssumptions = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/assumption",
      operationId: "getAssumptions",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetAssumptions({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostCertificateError = Fetcher.ErrorWrapper<undefined>;
export type PostCertificateVariables = {
  body: Schemas.CertificateData;
} & GatewayContext["fetcherOptions"];

/**
 * Request a certificate
 */
export const fetchPostCertificate = (variables: PostCertificateVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostCertificateError, Schemas.CertificateData, {}, {}, {}>({
  url: "/gateway/v1/certificate",
  method: "post",
  ...variables,
  signal
});

/**
 * Request a certificate
 */
export const usePostCertificate = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostCertificate({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetCertificateByTokenPathParams = {
  token: string;
};
export type GetCertificateByTokenError = Fetcher.ErrorWrapper<undefined>;
export type GetCertificateByTokenVariables = {
  pathParams: GetCertificateByTokenPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetCertificateByToken = (variables: GetCertificateByTokenVariables, signal?: AbortSignal) => gatewayFetch<undefined, GetCertificateByTokenError, undefined, {}, {}, GetCertificateByTokenPathParams>({
  url: "/gateway/v1/certificate/{token}",
  method: "get",
  ...variables,
  signal
});
export const useGetCertificateByToken = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/certificate/{token}",
      operationId: "getCertificateByToken",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetCertificateByToken({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostInterestRateUpdateOptInError = Fetcher.ErrorWrapper<undefined>;
export type PostInterestRateUpdateOptInVariables = {
  body: Schemas.InterestRateOptInRequest;
} & GatewayContext["fetcherOptions"];

/**
 * Records the interest rate update opt-in for the lead identified by the token. Requires an explicit confirmation on the opt-in page so that email clients following the link cannot subscribe the customer.
 */
export const fetchPostInterestRateUpdateOptIn = (variables: PostInterestRateUpdateOptInVariables, signal?: AbortSignal) => gatewayFetch<Schemas.InterestRateOptInResponse, PostInterestRateUpdateOptInError, Schemas.InterestRateOptInRequest, {}, {}, {}>({
  url: "/gateway/v1/interest-rate-update/opt-in",
  method: "post",
  ...variables,
  signal
});

/**
 * Records the interest rate update opt-in for the lead identified by the token. Requires an explicit confirmation on the opt-in page so that email clients following the link cannot subscribe the customer.
 */
export const usePostInterestRateUpdateOptIn = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostInterestRateUpdateOptIn({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetInterestRateUpdateOptInStatusPathParams = {
  token: string;
};
export type GetInterestRateUpdateOptInStatusError = Fetcher.ErrorWrapper<undefined>;
export type GetInterestRateUpdateOptInStatusVariables = {
  pathParams: GetInterestRateUpdateOptInStatusPathParams;
} & GatewayContext["fetcherOptions"];

/**
 * Reports whether the lead identified by the token is already subscribed, without changing the subscription, so that the opt-in page can show the confirmation to customers who follow the link again.
 */
export const fetchGetInterestRateUpdateOptInStatus = (variables: GetInterestRateUpdateOptInStatusVariables, signal?: AbortSignal) => gatewayFetch<Schemas.InterestRateOptInResponse, GetInterestRateUpdateOptInStatusError, undefined, {}, {}, GetInterestRateUpdateOptInStatusPathParams>({
  url: "/gateway/v1/interest-rate-update/opt-in/{token}",
  method: "get",
  ...variables,
  signal
});

/**
 * Reports whether the lead identified by the token is already subscribed, without changing the subscription, so that the opt-in page can show the confirmation to customers who follow the link again.
 */
export const useGetInterestRateUpdateOptInStatus = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/interest-rate-update/opt-in/{token}",
      operationId: "getInterestRateUpdateOptInStatus",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetInterestRateUpdateOptInStatus({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetEmailRedirectQueryParams = {
  /**
   * @format uri
   */
  target: string;
  type?: string;
  lead_id?: string;
  hubspot_contact_id?: string;
  hubspot_partner_contact_id?: string;
};
export type GetEmailRedirectError = Fetcher.ErrorWrapper<undefined>;
export type GetEmailRedirectVariables = {
  queryParams: GetEmailRedirectQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetEmailRedirect = (variables: GetEmailRedirectVariables, signal?: AbortSignal) => gatewayFetch<undefined, GetEmailRedirectError, undefined, {}, GetEmailRedirectQueryParams, {}>({
  url: "/gateway/v1/email",
  method: "get",
  ...variables,
  signal
});
export const useGetEmailRedirect = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/email",
      operationId: "getEmailRedirect",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetEmailRedirect({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type CreateFrontendStateError = Fetcher.ErrorWrapper<undefined>;
export type CreateFrontendStateVariables = {
  body: Schemas.FrontendState;
} & GatewayContext["fetcherOptions"];
export const fetchCreateFrontendState = (variables: CreateFrontendStateVariables, signal?: AbortSignal) => gatewayFetch<Schemas.FrontendState, CreateFrontendStateError, Schemas.FrontendState, {}, {}, {}>({
  url: "/gateway/v1/frontend-state",
  method: "post",
  ...variables,
  signal
});
export const useCreateFrontendState = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchCreateFrontendState({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetFrontendStatePathParams = {
  id: string;
};
export type GetFrontendStateQueryParams = {
  token: string;
};
export type GetFrontendStateError = Fetcher.ErrorWrapper<undefined>;
export type GetFrontendStateVariables = {
  pathParams: GetFrontendStatePathParams;
  queryParams: GetFrontendStateQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetFrontendState = (variables: GetFrontendStateVariables, signal?: AbortSignal) => gatewayFetch<Schemas.FrontendState, GetFrontendStateError, undefined, {}, GetFrontendStateQueryParams, GetFrontendStatePathParams>({
  url: "/gateway/v1/frontend-state/{id}",
  method: "get",
  ...variables,
  signal
});
export const useGetFrontendState = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/frontend-state/{id}",
      operationId: "getFrontendState",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetFrontendState({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type UpdateFrontendStatePathParams = {
  id: string;
};
export type UpdateFrontendStateError = Fetcher.ErrorWrapper<undefined>;
export type UpdateFrontendStateVariables = {
  body: Schemas.FrontendState;
  pathParams: UpdateFrontendStatePathParams;
} & GatewayContext["fetcherOptions"];
export const fetchUpdateFrontendState = (variables: UpdateFrontendStateVariables, signal?: AbortSignal) => gatewayFetch<undefined, UpdateFrontendStateError, Schemas.FrontendState, {}, {}, UpdateFrontendStatePathParams>({
  url: "/gateway/v1/frontend-state/{id}",
  method: "put",
  ...variables,
  signal
});
export const useUpdateFrontendState = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchUpdateFrontendState({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostLeadError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;
export type PostLeadVariables = {
  body: Schemas.Lead;
} & GatewayContext["fetcherOptions"];

/**
 * Create a lead
 */
export const fetchPostLead = (variables: PostLeadVariables, signal?: AbortSignal) => gatewayFetch<Schemas.LeadCreationResponse, PostLeadError, Schemas.Lead, {}, {}, {}>({
  url: "/gateway/v1/lead",
  method: "post",
  ...variables,
  signal
});

/**
 * Create a lead
 */
export const usePostLead = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostLead({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostAppAccessError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;
export type PostAppAccessVariables = {
  body: Schemas.AppAccessRequest;
} & GatewayContext["fetcherOptions"];

/**
 * Request app access
 */
export const fetchPostAppAccess = (variables: PostAppAccessVariables, signal?: AbortSignal) => gatewayFetch<Schemas.AppAccessResponse, PostAppAccessError, Schemas.AppAccessRequest, {}, {}, {}>({
  url: "/gateway/v1/app-access",
  method: "post",
  ...variables,
  signal
});

/**
 * Request app access
 */
export const usePostAppAccess = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostAppAccess({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostMeetingLeadQueryParams = {
  clientMode?: Schemas.ClientMode;
};
export type PostMeetingLeadError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;
export type PostMeetingLeadVariables = {
  body: Schemas.MeetingLead;
  queryParams?: PostMeetingLeadQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchPostMeetingLead = (variables: PostMeetingLeadVariables, signal?: AbortSignal) => gatewayFetch<Schemas.LeadCreationResponse, PostMeetingLeadError, Schemas.MeetingLead, {}, PostMeetingLeadQueryParams, {}>({
  url: "/gateway/v1/meeting/lead",
  method: "post",
  ...variables,
  signal
});
export const usePostMeetingLead = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostMeetingLead({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostMeetingReconfirmationError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;
export type PostMeetingReconfirmationVariables = {
  body: Schemas.MeetingReconfirmation;
} & GatewayContext["fetcherOptions"];
export const fetchPostMeetingReconfirmation = (variables: PostMeetingReconfirmationVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostMeetingReconfirmationError, Schemas.MeetingReconfirmation, {}, {}, {}>({
  url: "/gateway/v1/meeting/reconfirmation",
  method: "post",
  ...variables,
  signal
});
export const usePostMeetingReconfirmation = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostMeetingReconfirmation({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostMeetingCallbackFormShownError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;
export type PostMeetingCallbackFormShownVariables = {
  body: Schemas.MeetingCallbackFormShown;
} & GatewayContext["fetcherOptions"];
export const fetchPostMeetingCallbackFormShown = (variables: PostMeetingCallbackFormShownVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostMeetingCallbackFormShownError, Schemas.MeetingCallbackFormShown, {}, {}, {}>({
  url: "/gateway/v1/meeting/callback-form-shown",
  method: "post",
  ...variables,
  signal
});
export const usePostMeetingCallbackFormShown = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostMeetingCallbackFormShown({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetLeadQualificationPathParams = {
  leadId: string;
};
export type GetLeadQualificationError = Fetcher.ErrorWrapper<undefined>;
export type GetLeadQualificationVariables = {
  pathParams: GetLeadQualificationPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetLeadQualification = (variables: GetLeadQualificationVariables, signal?: AbortSignal) => gatewayFetch<Schemas.LeadQualification, GetLeadQualificationError, undefined, {}, {}, GetLeadQualificationPathParams>({
  url: "/gateway/v1/lead/{leadId}/qualification",
  method: "get",
  ...variables,
  signal
});
export const useGetLeadQualification = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/lead/{leadId}/qualification",
      operationId: "getLeadQualification",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetLeadQualification({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetLeadCalendarPathParams = {
  leadId: string;
};
export type GetLeadCalendarQueryParams = {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  hubspotUtk?: string;
  calendarType?: Schemas.CalendarType;
};
export type GetLeadCalendarError = Fetcher.ErrorWrapper<undefined>;
export type GetLeadCalendarVariables = {
  pathParams: GetLeadCalendarPathParams;
  queryParams?: GetLeadCalendarQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetLeadCalendar = (variables: GetLeadCalendarVariables, signal?: AbortSignal) => gatewayFetch<string, GetLeadCalendarError, undefined, {}, GetLeadCalendarQueryParams, GetLeadCalendarPathParams>({
  url: "/gateway/v1/lead/{leadId}/calendar",
  method: "get",
  ...variables,
  signal
});
export const useGetLeadCalendar = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/lead/{leadId}/calendar",
      operationId: "getLeadCalendar",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetLeadCalendar({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetLeadBookingQualificationRequirementsQueryParams = {
  leadId?: string;
  projectId?: string;
  partnerId?: string;
  dealId?: string;
};
export type GetLeadBookingQualificationRequirementsError = Fetcher.ErrorWrapper<undefined>;
export type GetLeadBookingQualificationRequirementsVariables = {
  queryParams?: GetLeadBookingQualificationRequirementsQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetLeadBookingQualificationRequirements = (variables: GetLeadBookingQualificationRequirementsVariables, signal?: AbortSignal) => gatewayFetch<Schemas.BookingQualificationRequirements, GetLeadBookingQualificationRequirementsError, undefined, {}, GetLeadBookingQualificationRequirementsQueryParams, {}>({
  url: "/gateway/v1/lead/booking-qualification-requirements",
  method: "get",
  ...variables,
  signal
});
export const useGetLeadBookingQualificationRequirements = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/lead/booking-qualification-requirements",
      operationId: "getLeadBookingQualificationRequirements",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetLeadBookingQualificationRequirements({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type ShareMedalRatingEmailQueryParams = {
  leadId?: string;
  hubspotDealId?: string;
};
export type ShareMedalRatingEmailError = Fetcher.ErrorWrapper<undefined>;
export type ShareMedalRatingEmailVariables = {
  queryParams?: ShareMedalRatingEmailQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchShareMedalRatingEmail = (variables: ShareMedalRatingEmailVariables, signal?: AbortSignal) => gatewayFetch<undefined, ShareMedalRatingEmailError, undefined, {}, ShareMedalRatingEmailQueryParams, {}>({
  url: "/gateway/v1/lead/share-medal-rating",
  method: "get",
  ...variables,
  signal
});
export const useShareMedalRatingEmail = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/lead/share-medal-rating",
      operationId: "shareMedalRatingEmail",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchShareMedalRatingEmail({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostLeadActionPathParams = {
  leadId: string;
};
export type PostLeadActionError = Fetcher.ErrorWrapper<undefined>;
export type PostLeadActionVariables = {
  body: Schemas.LeadAction;
  pathParams: PostLeadActionPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchPostLeadAction = (variables: PostLeadActionVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostLeadActionError, Schemas.LeadAction, {}, {}, PostLeadActionPathParams>({
  url: "/gateway/v1/lead/{leadId}/action",
  method: "post",
  ...variables,
  signal
});
export const usePostLeadAction = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostLeadAction({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PutMedalRatingPathParams = {
  leadId: string;
};
export type PutMedalRatingQueryParams = {
  clientMode: Schemas.ClientMode;
  applicationId?: string;
  projectId?: string;
};
export type PutMedalRatingError = Fetcher.ErrorWrapper<undefined>;
export type PutMedalRatingVariables = {
  body: Schemas.MedalRatingBody;
  pathParams: PutMedalRatingPathParams;
  queryParams: PutMedalRatingQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchPutMedalRating = (variables: PutMedalRatingVariables, signal?: AbortSignal) => gatewayFetch<undefined, PutMedalRatingError, Schemas.MedalRatingBody, {}, PutMedalRatingQueryParams, PutMedalRatingPathParams>({
  url: "/gateway/v1/lead/{leadId}/medal-rating",
  method: "put",
  ...variables,
  signal
});
export const usePutMedalRating = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPutMedalRating({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ConfirmManualLeadReferralPathParams = {
  leadId: string;
  projectId: string;
};
export type ConfirmManualLeadReferralError = Fetcher.ErrorWrapper<undefined>;
export type ConfirmManualLeadReferralVariables = {
  pathParams: ConfirmManualLeadReferralPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchConfirmManualLeadReferral = (variables: ConfirmManualLeadReferralVariables, signal?: AbortSignal) => gatewayFetch<undefined, ConfirmManualLeadReferralError, undefined, {}, {}, ConfirmManualLeadReferralPathParams>({
  url: "/gateway/v1/lead/{leadId}/project/{projectId}/referral-confirmation",
  method: "get",
  ...variables,
  signal
});
export const useConfirmManualLeadReferral = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/lead/{leadId}/project/{projectId}/referral-confirmation",
      operationId: "confirmManualLeadReferral",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchConfirmManualLeadReferral({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostAppAccessRequestedPathParams = {
  leadId: string;
  projectId: string;
};
export type PostAppAccessRequestedError = Fetcher.ErrorWrapper<undefined>;
export type PostAppAccessRequestedVariables = {
  pathParams: PostAppAccessRequestedPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchPostAppAccessRequested = (variables: PostAppAccessRequestedVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostAppAccessRequestedError, undefined, {}, {}, PostAppAccessRequestedPathParams>({
  url: "/gateway/v1/lead/{leadId}/project/{projectId}/app-access-requested",
  method: "post",
  ...variables,
  signal
});
export const usePostAppAccessRequested = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostAppAccessRequested({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostMaximumBudgetError = Fetcher.ErrorWrapper<undefined>;
export type PostMaximumBudgetVariables = {
  body: Schemas.MaximumBudget;
} & GatewayContext["fetcherOptions"];
export const fetchPostMaximumBudget = (variables: PostMaximumBudgetVariables, signal?: AbortSignal) => gatewayFetch<Schemas.MaximumBudget, PostMaximumBudgetError, Schemas.MaximumBudget, {}, {}, {}>({
  url: "/gateway/v1/maximum-budget",
  method: "post",
  ...variables,
  signal
});
export const usePostMaximumBudget = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostMaximumBudget({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetPartnerByOnofficeWebCustomerIdPathParams = {
  webCustomerId: string;
};
export type GetPartnerByOnofficeWebCustomerIdQueryParams = {
  userId?: number;
};
export type GetPartnerByOnofficeWebCustomerIdError = Fetcher.ErrorWrapper<undefined>;
export type GetPartnerByOnofficeWebCustomerIdVariables = {
  pathParams: GetPartnerByOnofficeWebCustomerIdPathParams;
  queryParams?: GetPartnerByOnofficeWebCustomerIdQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetPartnerByOnofficeWebCustomerId = (variables: GetPartnerByOnofficeWebCustomerIdVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Partner, GetPartnerByOnofficeWebCustomerIdError, undefined, {}, GetPartnerByOnofficeWebCustomerIdQueryParams, GetPartnerByOnofficeWebCustomerIdPathParams>({
  url: "/gateway/v1/partner/onoffice/{webCustomerId}",
  method: "get",
  ...variables,
  signal
});
export const useGetPartnerByOnofficeWebCustomerId = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/partner/onoffice/{webCustomerId}",
      operationId: "getPartnerByOnofficeWebCustomerId",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetPartnerByOnofficeWebCustomerId({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetPartnerByPropstackCompanyIdPathParams = {
  companyId: number;
};
export type GetPartnerByPropstackCompanyIdError = Fetcher.ErrorWrapper<undefined>;
export type GetPartnerByPropstackCompanyIdVariables = {
  pathParams: GetPartnerByPropstackCompanyIdPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetPartnerByPropstackCompanyId = (variables: GetPartnerByPropstackCompanyIdVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Partner, GetPartnerByPropstackCompanyIdError, undefined, {}, {}, GetPartnerByPropstackCompanyIdPathParams>({
  url: "/gateway/v1/partner/propstack/{companyId}/",
  method: "get",
  ...variables,
  signal
});
export const useGetPartnerByPropstackCompanyId = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/partner/propstack/{companyId}/",
      operationId: "getPartnerByPropstackCompanyId",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetPartnerByPropstackCompanyId({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetPartnerPathParams = {
  id: string;
};
export type GetPartnerQueryParams = {
  property?: Schemas.GetPartnerPropertyEnum;
  userId?: number;
};
export type GetPartnerError = Fetcher.ErrorWrapper<undefined>;
export type GetPartnerVariables = {
  pathParams: GetPartnerPathParams;
  queryParams?: GetPartnerQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetPartner = (variables: GetPartnerVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Partner, GetPartnerError, undefined, {}, GetPartnerQueryParams, GetPartnerPathParams>({
  url: "/gateway/v1/partner/{id}",
  method: "get",
  ...variables,
  signal
});
export const useGetPartner = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/partner/{id}",
      operationId: "getPartner",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetPartner({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostPartnerApplicationPathParams = {
  partnerId: string;
};
export type PostPartnerApplicationQueryParams = {
  clientMode: Schemas.ClientMode;
  /**
   * When set, the calculated application is attached to this project once it is stored
   */
  projectId?: string;
  /**
   * CRM contact the widget was opened for, required together with projectId
   */
  contactId?: string;
  /**
   * Whether the preceding lead request created the lead, as reported by its response
   */
  leadCreated?: boolean;
};
export type PostPartnerApplicationError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;
export type PostPartnerApplicationVariables = {
  body: Schemas.PartnerCRMApplication;
  pathParams: PostPartnerApplicationPathParams;
  queryParams: PostPartnerApplicationQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchPostPartnerApplication = (variables: PostPartnerApplicationVariables, signal?: AbortSignal) => gatewayFetch<Schemas.Application, PostPartnerApplicationError, Schemas.PartnerCRMApplication, {}, PostPartnerApplicationQueryParams, PostPartnerApplicationPathParams>({
  url: "/gateway/v1/partner/{partnerId}/application",
  method: "post",
  ...variables,
  signal
});
export const usePostPartnerApplication = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostPartnerApplication({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type PostPartnerLeadPathParams = {
  partnerId: string;
};
export type PostPartnerLeadQueryParams = {
  clientMode: Schemas.ClientMode;
};
export type PostPartnerLeadError = Fetcher.ErrorWrapper<undefined>;
export type PostPartnerLeadVariables = {
  body: Schemas.PartnerCRMLead;
  pathParams: PostPartnerLeadPathParams;
  queryParams: PostPartnerLeadQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchPostPartnerLead = (variables: PostPartnerLeadVariables, signal?: AbortSignal) => gatewayFetch<Schemas.LeadCreationResponse, PostPartnerLeadError, Schemas.PartnerCRMLead, {}, PostPartnerLeadQueryParams, PostPartnerLeadPathParams>({
  url: "/gateway/v1/partner/{partnerId}/lead",
  method: "post",
  ...variables,
  signal
});
export const usePostPartnerLead = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostPartnerLead({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetPartnerPropertyPathParams = {
  partnerId: string;
  propertyId: string;
};
export type GetPartnerPropertyQueryParams = {
  clientMode: Schemas.ClientMode;
};
export type GetPartnerPropertyError = Fetcher.ErrorWrapper<undefined>;
export type GetPartnerPropertyVariables = {
  pathParams: GetPartnerPropertyPathParams;
  queryParams: GetPartnerPropertyQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetPartnerProperty = (variables: GetPartnerPropertyVariables, signal?: AbortSignal) => gatewayFetch<Schemas.PartnerCRMProperty, GetPartnerPropertyError, undefined, {}, GetPartnerPropertyQueryParams, GetPartnerPropertyPathParams>({
  url: "/gateway/v1/partner/{partnerId}/property/{propertyId}",
  method: "get",
  ...variables,
  signal
});
export const useGetPartnerProperty = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/partner/{partnerId}/property/{propertyId}",
      operationId: "getPartnerProperty",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetPartnerProperty({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type SearchPlacesError = Fetcher.ErrorWrapper<undefined>;
export type SearchPlacesResponse = Schemas.Place[];
export type SearchPlacesVariables = {
  body: Schemas.SearchPlace;
} & GatewayContext["fetcherOptions"];
export const fetchSearchPlaces = (variables: SearchPlacesVariables, signal?: AbortSignal) => gatewayFetch<SearchPlacesResponse, SearchPlacesError, Schemas.SearchPlace, {}, {}, {}>({
  url: "/gateway/v1/places",
  method: "post",
  ...variables,
  signal
});
export const useSearchPlaces = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchSearchPlaces({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetReviewSummaryError = Fetcher.ErrorWrapper<undefined>;
export type GetReviewSummaryVariables = GatewayContext["fetcherOptions"];
export const fetchGetReviewSummary = (variables: GetReviewSummaryVariables, signal?: AbortSignal) => gatewayFetch<Schemas.GoogleReviewSummary, GetReviewSummaryError, undefined, {}, {}, {}>({
  url: "/gateway/v1/reviews/summary",
  method: "get",
  ...variables,
  signal
});
export const useGetReviewSummary = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/reviews/summary",
      operationId: "getReviewSummary",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetReviewSummary({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type SaveFirstMeetingNpsPathParams = {
  projectId: string;
};
export type SaveFirstMeetingNpsQueryParams = {
  advisorId: string;
  rt: number;
};
export type SaveFirstMeetingNpsError = Fetcher.ErrorWrapper<undefined>;
export type SaveFirstMeetingNpsVariables = {
  pathParams: SaveFirstMeetingNpsPathParams;
  queryParams: SaveFirstMeetingNpsQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchSaveFirstMeetingNps = (variables: SaveFirstMeetingNpsVariables, signal?: AbortSignal) => gatewayFetch<undefined, SaveFirstMeetingNpsError, undefined, {}, SaveFirstMeetingNpsQueryParams, SaveFirstMeetingNpsPathParams>({
  url: "/gateway/v1/projects/{projectId}/meeting-nps",
  method: "get",
  ...variables,
  signal
});
export const useSaveFirstMeetingNps = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/projects/{projectId}/meeting-nps",
      operationId: "saveFirstMeetingNps",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchSaveFirstMeetingNps({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type SaveRealtorNpsPathParams = {
  projectId: string;
};
export type SaveRealtorNpsQueryParams = {
  score: number;
  partnerId: string;
  realtorEmail: string;
  brokerId: number;
};
export type SaveRealtorNpsError = Fetcher.ErrorWrapper<undefined>;
export type SaveRealtorNpsVariables = {
  pathParams: SaveRealtorNpsPathParams;
  queryParams: SaveRealtorNpsQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchSaveRealtorNps = (variables: SaveRealtorNpsVariables, signal?: AbortSignal) => gatewayFetch<undefined, SaveRealtorNpsError, undefined, {}, SaveRealtorNpsQueryParams, SaveRealtorNpsPathParams>({
  url: "/gateway/v1/projects/{projectId}/realtor-nps",
  method: "get",
  ...variables,
  signal
});
export const useSaveRealtorNps = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/projects/{projectId}/realtor-nps",
      operationId: "saveRealtorNps",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchSaveRealtorNps({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type GetSavedOffersPdfByTokenPathParams = {
  token: string;
};
export type GetSavedOffersPdfByTokenError = Fetcher.ErrorWrapper<undefined>;
export type GetSavedOffersPdfByTokenVariables = {
  pathParams: GetSavedOffersPdfByTokenPathParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetSavedOffersPdfByToken = (variables: GetSavedOffersPdfByTokenVariables, signal?: AbortSignal) => gatewayFetch<undefined, GetSavedOffersPdfByTokenError, undefined, {}, {}, GetSavedOffersPdfByTokenPathParams>({
  url: "/gateway/v1/saved-offers-pdf/{token}",
  method: "get",
  ...variables,
  signal
});
export const useGetSavedOffersPdfByToken = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/gateway/v1/saved-offers-pdf/{token}",
      operationId: "getSavedOffersPdfByToken",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetSavedOffersPdfByToken({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostSubscriptionError = Fetcher.ErrorWrapper<undefined>;
export type PostSubscriptionVariables = {
  body: Schemas.Subscription;
} & GatewayContext["fetcherOptions"];
export const fetchPostSubscription = (variables: PostSubscriptionVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostSubscriptionError, Schemas.Subscription, {}, {}, {}>({
  url: "/gateway/v1/subscription",
  method: "post",
  ...variables,
  signal
});
export const usePostSubscription = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostSubscription({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetInterestRateChartQueryParams = {
  period?: string;
};
export type GetInterestRateChartHeaders = {
  Authorization: string;
};
export type GetInterestRateChartError = Fetcher.ErrorWrapper<undefined>;
export type GetInterestRateChartResponse = Schemas.InterestRate[];
export type GetInterestRateChartVariables = {
  headers: GetInterestRateChartHeaders;
  queryParams?: GetInterestRateChartQueryParams;
} & GatewayContext["fetcherOptions"];
export const fetchGetInterestRateChart = (variables: GetInterestRateChartVariables, signal?: AbortSignal) => gatewayFetch<GetInterestRateChartResponse, GetInterestRateChartError, undefined, GetInterestRateChartHeaders, GetInterestRateChartQueryParams, {}>({
  url: "/interest-rates",
  method: "get",
  ...variables,
  signal
});
export const useGetInterestRateChart = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useGatewayContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/interest-rates",
      operationId: "getInterestRateChart",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetInterestRateChart({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type PostOnofficeApiTokenError = Fetcher.ErrorWrapper<undefined>;
export type PostOnofficeApiTokenVariables = {
  body: Schemas.OnOfficeApiToken;
} & GatewayContext["fetcherOptions"];
export const fetchPostOnofficeApiToken = (variables: PostOnofficeApiTokenVariables, signal?: AbortSignal) => gatewayFetch<undefined, PostOnofficeApiTokenError, Schemas.OnOfficeApiToken, {}, {}, {}>({
  url: "/partner/onoffice/api-key",
  method: "post",
  ...variables,
  signal
});
export const usePostOnofficeApiToken = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useGatewayContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchPostOnofficeApiToken({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type QueryOperation = {
  path: "/advisors";
  operationId: "getAdvisors";
  variables: GetAdvisorsVariables;
} | {
  path: "/advisors/{advisorId}/meetings";
  operationId: "getAdvisorMeetings";
  variables: GetAdvisorMeetingsVariables;
} | {
  path: "/gateway/v1/aircall/redirect";
  operationId: "getAircallRedirect";
  variables: GetAircallRedirectVariables;
} | {
  path: "/gateway/v1/application/{applicationId}";
  operationId: "getApplicationResults";
  variables: GetApplicationResultsVariables;
} | {
  path: "/gateway/v1/advisor-calendar";
  operationId: "getAdvisorCalendar";
  variables: GetAdvisorCalendarVariables;
} | {
  path: "/gateway/v1/assumption";
  operationId: "getAssumptions";
  variables: GetAssumptionsVariables;
} | {
  path: "/gateway/v1/certificate/{token}";
  operationId: "getCertificateByToken";
  variables: GetCertificateByTokenVariables;
} | {
  path: "/gateway/v1/interest-rate-update/opt-in/{token}";
  operationId: "getInterestRateUpdateOptInStatus";
  variables: GetInterestRateUpdateOptInStatusVariables;
} | {
  path: "/gateway/v1/email";
  operationId: "getEmailRedirect";
  variables: GetEmailRedirectVariables;
} | {
  path: "/gateway/v1/frontend-state/{id}";
  operationId: "getFrontendState";
  variables: GetFrontendStateVariables;
} | {
  path: "/gateway/v1/lead/{leadId}/qualification";
  operationId: "getLeadQualification";
  variables: GetLeadQualificationVariables;
} | {
  path: "/gateway/v1/lead/{leadId}/calendar";
  operationId: "getLeadCalendar";
  variables: GetLeadCalendarVariables;
} | {
  path: "/gateway/v1/lead/booking-qualification-requirements";
  operationId: "getLeadBookingQualificationRequirements";
  variables: GetLeadBookingQualificationRequirementsVariables;
} | {
  path: "/gateway/v1/lead/share-medal-rating";
  operationId: "shareMedalRatingEmail";
  variables: ShareMedalRatingEmailVariables;
} | {
  path: "/gateway/v1/lead/{leadId}/project/{projectId}/referral-confirmation";
  operationId: "confirmManualLeadReferral";
  variables: ConfirmManualLeadReferralVariables;
} | {
  path: "/gateway/v1/partner/onoffice/{webCustomerId}";
  operationId: "getPartnerByOnofficeWebCustomerId";
  variables: GetPartnerByOnofficeWebCustomerIdVariables;
} | {
  path: "/gateway/v1/partner/propstack/{companyId}/";
  operationId: "getPartnerByPropstackCompanyId";
  variables: GetPartnerByPropstackCompanyIdVariables;
} | {
  path: "/gateway/v1/partner/{id}";
  operationId: "getPartner";
  variables: GetPartnerVariables;
} | {
  path: "/gateway/v1/partner/{partnerId}/property/{propertyId}";
  operationId: "getPartnerProperty";
  variables: GetPartnerPropertyVariables;
} | {
  path: "/gateway/v1/reviews/summary";
  operationId: "getReviewSummary";
  variables: GetReviewSummaryVariables;
} | {
  path: "/gateway/v1/projects/{projectId}/meeting-nps";
  operationId: "saveFirstMeetingNps";
  variables: SaveFirstMeetingNpsVariables;
} | {
  path: "/gateway/v1/projects/{projectId}/realtor-nps";
  operationId: "saveRealtorNps";
  variables: SaveRealtorNpsVariables;
} | {
  path: "/gateway/v1/saved-offers-pdf/{token}";
  operationId: "getSavedOffersPdfByToken";
  variables: GetSavedOffersPdfByTokenVariables;
} | {
  path: "/interest-rates";
  operationId: "getInterestRateChart";
  variables: GetInterestRateChartVariables;
};